import React, { useEffect, useMemo } from 'react'
import { useInstData } from 'tyan/public/hooks'
import ListBox from './components/ListBox'

const Template = props => {
	const { name, birthday } = props
	const dateValue = Ext.Date.utcToLocal(new Date(birthday))
	return <div style={{ display: 'flex', flexDirection: 'row', height: '26px', lineHeight: '26px' }}>
		<span style={{ flex: 1 }}>{name}</span>
		<span >{`${dateValue.getMonth() + 1}月${dateValue.getDate()}日`}</span>
	</div>
}


const Birthdays = props => {
	const { setState, me: { state: { data } } } = useInstData(props)
	useEffect(() => {
		Tyan.doPostEvent({
			event: 'GetBirthdays',
			data: {},
			onEnd: ({ errorMessage, birthdays }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				setState({ data: birthdays })
			}
		})
	}, [])

	return <ListBox data={data} template={Template} />
}

export default Birthdays